import React, { useState, useMemo, useCallback } from "react";
import "./DimensionsAndSubDimensions.css";
import * as FeatherIcon from "react-feather";

//All Dimensions & Subdimensions
export const TAB_STRUCTURE = {
  executiveSnap: {
    heading: "Executive Snapshot",
    children: [
      // "Company Overview",
      // "Insight Summary",
      // "Overall Competitive Threat Assessment",
      // "Company Scorecard",
      // "Company Baseline Profile",
      "Overall Competitive Threat Assessment",
      "Executive Summary Next Steps",
      "Company Overview",
      "OpsSupply ScoreCard",
      "MarketingDistributions ScoreCard",
      "FinancialsStrategy ScoreCard",
      "MarketPosition ScoreCard",
      "OrgLeader ScoreCard",
      // "Company Insights",
      "ProdInno ScoreCard",
    ],
  },

  profileMarketPosition: {
    heading: "Market Position & Customer Intelligence",
    children: [
      // "Insight Summary",
      // "Market by Technology",
      // "Market by Application",
      // "Market by Geography",
      // "Market Share Analysis",
      // "Customer Segment Analysis",
      // "Key Expansions & Strategic Initiatives",
      "Market by application",
      "Key Expansions & Strategic Initiatives",
      "Market by technology",
      "Market by geography",
      // "Strategic Analysis",
      "Market Share Analysis",
      "Customer Segment Analysis",
    ],
  },

  profileProductInnovation: {
    heading: "Product & Innovation",
    children: [
      // "Insight Summary",
      // "Product & Solutions Portfolio",
      // "Product Launches & Related Activities",
      // "Patents & IP Activity",
      // "Technology Capability Assessment",
      // "R&D Spend Estimates",
      // "R&D Focus",
      // "Innovation Theme Radar",
      "Product & Solution Portfolio",
      "Patents & IP Activity",
      "R&D Spend Estimates",
      "Innovation Theme Radar",
      "Product Launches & Related Activities",
      "Technology Capability Assessment",
      // 'Strategic Summary Analysis'
    ],
  },

  // financials: {
  //     heading: "Strategy & Financial Performance",
  //     children: [
  //         "Financial Performance Overview",
  //         "Future Bets & Leadership-Led Initiatives",
  //         "Financial Documents",
  //         "Strategic Themes",
  //     ],
  // },

  marketing: {
    heading: "Marketing & Distribution",
    children: [
      // "Insight Summary",
      // "Go-To-Market Model",
      // "Distribution Networks & Partnerships",
      // "Channel Mix & Utilization",
      // "Demand Generation & Acquisition Tactics",
      // "Marketing Investment & ROI Signals",
      // "Market Presence & Brand Signals",
      // "Messaging & Positioning",
      // "Digital Footprint Analysis",
      // "Advertising & Media Spend",
      // "Marketing Channels by Segment",
      // "Marketing & Geographic Coverage",
      "GTM & Distribution Strategy Analysis",
      "Marketing Geographic Coverage",
      "Digital Footprint Analysis",
      "Messaging & Positioning",
      // "Comprehensive Marketing Intelligence",
      "Market Presence & Brand Signals",
      "Demand Generation & Acquisition Tactics",
      "Marketing Investment & ROI Signals",
      "Marketing Channels by Segment",
      "Advertising & Media Spend",
    ],
  },

  operations: {
    heading: "Operations & Supply Chain",
    children: [
      // "Operations Insight Summary",
      // "Quantitative Snapshot",
      // "Global Operations Network",
      // "Tier 1 Suppliers",
      // "Raw Material Imports",
      // "Inbound Logistics",
      // "Warehousing & Channels",
      // "Outbound Distribution",
      // "Trade Exposure",
      // "Cost Structure Analysis",
      // "Sustainability, Finance, Innovation & Risk Analysis",
      "Quantitative Snapshot",
      "Capex Trends",
      "Inbound Logistics",
      "Raw Material Imports",
      "Tier 1 Suppliers",
      "Global Operations Network",
      "Cost Structure Analysis",
      "Trade Exposure",
      // 'Strategic Summary Analysis',
      "Outbound Distribution",
      "Sustainability, Finance, Innovation, Risks",
      "Warehousing & Channels",
    ],
  },

  orgStructure: {
    heading: "Corporate & Organizational Structure",
    children: [
      // "Executive Leadership Team",
      // "Organizational Hierarchy",
      // "Business Segment Structure",
      // "Strategic Leadership Themes",
      "Business Segment",
      "Executive Leadership Team",
      "Future Bets",
      "Executive Timeline",
      "Org Chart",
      "Strategic Themes",
    ],
  },
};

//Dimensions & Subdimensions for Market IQ
export const TAB_STRUCTURE_USER = {
  executiveSnap: {
    heading: "Executive Snapshot",
    children: [
      "Company Overview",
      "Executive Summary Next Steps",
      "OpsSupply ScoreCard",
      "ProdInno ScoreCard",
      "MarketingDistributions ScoreCard",
      "OrgLeader ScoreCard",
      "Overall Competitive Threat Assessment",
      "FinancialsStrategy ScoreCard",
      "MarketPosition ScoreCard",
    ],
  },

  profileProductInnovation: {
    heading: "Product & Innovation",
    children: ["Innovation Theme Radar", "R&D Spend Estimates"],
  },

  marketing: {
    heading: "Marketing & Distribution",
    children: ["GTM & Distribution Strategy Analysis"],
  },

  operations: {
    heading: "Operations & Supply Chain",
    children: [
      "Quantitative Snapshot",
      "Inbound Logistics",
      "Outbound Distribution",
      "Cost Structure Analysis",
      "Warehousing & Channels",
      "Raw Material Imports",
      "Global Operations Network",
    ],
  },
};

// First dimension's children selected by default
const firstDimKey = Object.keys(TAB_STRUCTURE)[0];
export const DEFAULT_SELECTED_KEYS = TAB_STRUCTURE[firstDimKey].children;

// All TAB_STRUCTURE_USER children selected by default
export const DEFAULT_SELECTED_KEYS_USER = Object.values(
  TAB_STRUCTURE_USER
).flatMap((dim) => dim.children);

const DimensionsSelector = ({
  selectedKeys = [],
  onSelectionChange,
  disabled,
  isMarketIQDemo = false,
}) => {
  const activeStructure = isMarketIQDemo ? TAB_STRUCTURE_USER : TAB_STRUCTURE;
  const [expandedGroups, setExpandedGroups] = useState(() => {
    const firstKey = Object.keys(activeStructure)[0];
    return { [firstKey]: true };
  });
  const dimensionKeys = useMemo(
    () => Object.keys(activeStructure),
    [activeStructure]
  );
  const selectedSet = useMemo(() => new Set(selectedKeys), [selectedKeys]);

  const toggleGroup = useCallback((dimKey) => {
    setExpandedGroups((prev) => ({ ...prev, [dimKey]: !prev[dimKey] }));
  }, []);

  // Handle parent (dimension heading) checkbox toggle
  const handleParentToggle = useCallback(
    (dimKey) => {
      if (disabled) return;
      const childKeys = activeStructure[dimKey].children;
      const allChildSelected = childKeys.every((k) => selectedSet.has(k));

      const newSet = new Set(selectedSet);
      if (allChildSelected) {
        childKeys.forEach((k) => newSet.delete(k));
      } else {
        childKeys.forEach((k) => newSet.add(k));
      }
      onSelectionChange([...newSet]);
    },
    [disabled, selectedSet, onSelectionChange, activeStructure]
  );

  // Handle individual subdimension checkbox toggle
  const handleChildToggle = useCallback(
    (key) => {
      if (disabled) return;
      const newSet = new Set(selectedSet);
      if (newSet.has(key)) {
        newSet.delete(key);
      } else {
        newSet.add(key);
      }
      onSelectionChange([...newSet]);
    },
    [disabled, selectedSet, onSelectionChange]
  );

  // Select All / Deselect All
  const allChildKeys = useMemo(() => {
    const keys = [];
    dimensionKeys.forEach((dimKey) => {
      activeStructure[dimKey].children.forEach((k) => keys.push(k));
    });
    return keys;
  }, [dimensionKeys, activeStructure]);

  const handleSelectAll = useCallback(() => {
    if (disabled) return;
    if (selectedKeys.length === allChildKeys.length) {
      onSelectionChange([]);
    } else {
      onSelectionChange([...allChildKeys]);
    }
  }, [disabled, selectedKeys, allChildKeys, onSelectionChange]);

  // Parent checkbox state
  const getParentState = (dimKey) => {
    const childKeys = activeStructure[dimKey].children;
    const checkedCount = childKeys.filter((k) => selectedSet.has(k)).length;
    if (checkedCount === 0) return "unchecked";
    if (checkedCount === childKeys.length) return "checked";
    return "indeterminate";
  };

  const isAllSelected = selectedKeys.length === allChildKeys.length;

  return (
    <div className="dims-selector">
      <label className="dims-selector-label">
        Select dimensions & subdimensions
      </label>

      <div className="dims-selector-toolbar">
        <button
          type="button"
          className="dims-selector-toggle-btn"
          onClick={handleSelectAll}
          disabled={disabled}
        >
          {isAllSelected ? "Deselect All" : "Select All"}
        </button>
        {selectedKeys.length > 0 && (
          <span className="dims-selector-count">
            {selectedKeys.length} selected
          </span>
        )}
      </div>

      {/* Market IQ User uses TAB_STRUCTURE_USER, others use TAB_STRUCTURE */}
      <div className="dims-selector-groups">
        {dimensionKeys.map((dimKey) => {
          const dim = activeStructure[dimKey];
          const childKeys = dim.children;
          const parentState = getParentState(dimKey);
          const isExpanded = expandedGroups[dimKey] === true;

          return (
            <div className="dims-group" key={dimKey}>
              <div className="dims-group-header">
                <input
                  type="checkbox"
                  className="dims-checkbox dims-parent-checkbox"
                  checked={parentState === "checked"}
                  ref={(el) => {
                    if (el) el.indeterminate = parentState === "indeterminate";
                  }}
                  onChange={() => handleParentToggle(dimKey)}
                  disabled={disabled}
                />
                <span
                  className="dims-group-heading"
                  onClick={() => toggleGroup(dimKey)}
                >
                  {dim.heading}
                </span>
                <span
                  className={`dims-chevron ${isExpanded ? "expanded" : ""}`}
                  onClick={() => toggleGroup(dimKey)}
                >
                  <FeatherIcon.ChevronDown
                    className="comp_icon"
                    width={"16px"}
                  />
                </span>
              </div>

              {isExpanded && (
                <div className="dims-children">
                  {childKeys.map((subKey) => (
                    <label className="dims-child-row" key={subKey}>
                      <input
                        type="checkbox"
                        className="dims-checkbox"
                        checked={selectedSet.has(subKey)}
                        onChange={() => handleChildToggle(subKey)}
                        disabled={disabled}
                      />
                      <span className="dims-child-label">{subKey}</span>
                    </label>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DimensionsSelector;
